export const toDateString = (date) => {
  let month = `${date.getMonth() + 1}`;
  let day = `${date.getDate()}`;
  const year = date.getFullYear();
  if (month.length < 2) {
    month = `0${month}`;
  }
  if (day.length < 2) {
    day = `0${day}`;
  }
  return [day, month, year].join('-');
};

export const timestampToDate = (timestamp) => (timestamp ? toDateString(new Date(timestamp)) : '-');

export const convertTimestampToDateWithoutTime = (timestamp, language = 'en-US') => {
  if (!timestamp) return null;
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString(language);
};

export const isValidDate = (date) => {
  return !isNaN(Date.parse(date));
};